<template>
  <div>
    <div class="text-muted">{{ $t('customer_assessment_terms_ui.root_cause_terms_help')}}</div>
    <div>
      <customer-assessment-terms :customer="customer" category="route" :defaultTerms="defaultTerms" @saved="handleSave($event)"></customer-assessment-terms>
    </div>
  </div>
</template>

<script>
import CustomerAssessmentTerms from '@/components/customer/CustomerAssessmentTerms'

import { each } from 'lodash'

export default {
  name: 'RootCauseTerms',
  components: {
    CustomerAssessmentTerms
  },
  props: {
    customer: Object
  },
  data () {
    return {
      isReady: false,
      customerAssessmentTerms: []
    }
  },
  methods: {
    handleSave (terms) {
      this.$store.dispatch(
        'globalMessagingModule/showSuccessFlashBanner',
        `${this.$i18n.t('root_cause_terms')} ${this.$i18n.t('generic_save_success')}`
      )
    }
  },
  computed: {
    defaultTerms () {
      const terms = [
        {
          type: 'action',
          value: this.$tc('customer_assessment_term_defaults.none'),
          locked: true
        },
        {
          type: 'action',
          value: this.$tc('customer_assessment_term_defaults.address_with_driver')
        },
        {
          type: 'action',
          value: this.$tc('customer_assessment_term_defaults.address_with_warehouse')
        },
        {
          type: 'action',
          value: this.$tc('customer_assessment_term_defaults.notify_maintenance')
        },
        {
          type: 'cause',
          value: this.$tc('customer_assessment_term_defaults.other'),
          locked: true
        },
        {
          type: 'cause',
          value: this.$tc('customer_assessment_term_defaults.malfunction_air_sensor')
        },
        {
          type: 'cause',
          value: this.$tc('customer_assessment_term_defaults.malfunction_reefer')
        },
        {
          type: 'cause',
          value: this.$tc('customer_assessment_term_defaults.pre_cool')
        },
        {
          type: 'cause',
          value: this.$tc('customer_assessment_term_defaults.start_temp')
        },
        {
          type: 'cause',
          value: this.$tc('customer_assessment_term_defaults.start_end_time')
        }
      ]

      each(terms, term => {
        term.customer_id = this.customer.id
        term.category = 'route'
      })

      return terms
    }
  }
}
</script>

<style scoped>
</style>
